import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useRef, useMemo, useCallback } from 'react';
import { noop } from 'lodash';
import styled from 'styled-components';
import { SelectCustom } from '../../SelectCustom/index.js';
import { Link as StyledLink } from '../../Link/index.js';

const HiddenLink = styled(StyledLink)`
  display: none;
`;
const MenuItem = ({
  name: menuName,
  items = [],
  isNativeSelect,
  onSelect = noop
}) => {
  const linkRef = useRef(null);
  const optionsMemo = useMemo(() => items.map(({
    name
  }) => ({
    label: name,
    value: name
  })), [items]);
  /**
   * @param _ can be a string or `undefined`, based off of `isNative` prop
   * @param option
   */

  const handleChange = useCallback((_, option) => {
    var _a, _b, _c, _d, _e, _f;

    const value = option === null || option === void 0 ? void 0 : option.value;
    const item = items.find(el => el.name === value);
    if (!item) return;
    (_a = linkRef === null || linkRef === void 0 ? void 0 : linkRef.current) === null || _a === void 0 ? void 0 : _a.setAttribute('href', (_b = item === null || item === void 0 ? void 0 : item.href) !== null && _b !== void 0 ? _b : ''); // cleans up possibly previously set values for the attribute

    (_c = linkRef === null || linkRef === void 0 ? void 0 : linkRef.current) === null || _c === void 0 ? void 0 : _c.removeAttribute('data-lnk'); // need to make a check to ensure the attribute is available,
    // otherwise it might set a `data-lnk` attribute with a string value of `undefined`

    if ((item === null || item === void 0 ? void 0 : item.lnk) && ((_e = (_d = linkRef === null || linkRef === void 0 ? void 0 : linkRef.current) === null || _d === void 0 ? void 0 : _d.dataset) === null || _e === void 0 ? void 0 : _e.lnk)) {
      linkRef.current.dataset.lnk = item.lnk;
    }

    if (item.onSelect) {
      item.onSelect();
    } // @ts-ignore


    if (onSelect) onSelect(item);
    (_f = linkRef === null || linkRef === void 0 ? void 0 : linkRef.current) === null || _f === void 0 ? void 0 : _f.click();
  }, [items, onSelect]);
  if (items && items.length === 0) return null;
  return jsxs(Fragment, {
    children: [jsx(SelectCustom, {
      autoLabelUpdate: false,
      boldLabel: false,
      "data-test": `footerMenu-${menuName}`,
      defaultValue: menuName,
      disabledOptionText: menuName,
      display: "inline-block",
      isNative: isNativeSelect,

      /* eslint-disable-next-line react/jsx-no-bind */
      onChange: handleChange,
      options: optionsMemo,
      placement: "top",
      size: isNativeSelect ? 'sm' : 'md',
      target: `footerMenu-${menuName}`,
      variant: "borderless"
    }, void 0), jsx(HiddenLink, {
      href: "#",
      ref: linkRef
    }, void 0)]
  }, void 0);
};
MenuItem.displayName = 'MenuItem';

export { MenuItem };
